import React from 'react';
import { FiUser, FiCreditCard, FiCalendar } from 'react-icons/fi';

const FeeTransactionCard = ({ transaction, onClick }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 2
    }).format(amount || 0);
  };

  const getStatusBadge = (status) => {
    const baseClasses = "px-2 py-1 text-xs font-medium rounded-full";
    
    const statusConfig = {
      'successful': { bg: 'bg-green-100', text: 'text-green-800', label: 'Success' },
      'pending': { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Pending' },
      'failed': { bg: 'bg-red-100', text: 'text-red-800', label: 'Failed' }
    };

    const config = statusConfig[status] || { bg: 'bg-gray-100', text: 'text-gray-800', label: status };
    
    return (
      <span className={`${baseClasses} ${config.bg} ${config.text}`}>
        {config.label}
      </span>
    );
  };

  const getTypeBadge = (type) => {
    if (type === 'credit') {
      return <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">Credit</span>;
    }
    return <span className="px-2 py-1 bg-red-100 text-red-800 text-xs font-medium rounded-full">Debit</span>;
  };

  return (
    <div 
      onClick={() => onClick && onClick(transaction)}
      className="bg-white border border-gray-200 rounded-lg p-4 hover:border-[#ff660e] hover:shadow-sm transition-all duration-200 cursor-pointer"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center space-x-2 mb-2">
            {getTypeBadge(transaction.type)}
            {getStatusBadge(transaction.status)}
            <span className="text-xs text-gray-500">
              {transaction.transaction_type?.replace('_', ' ') || 'Transaction'}
            </span>
          </div>
          
          <div className="text-sm font-medium text-gray-900">
            {transaction.description}
          </div>
          
          <div className="text-xs text-gray-500 font-mono mt-1">
            {transaction.reference}
          </div>
        </div>
        
        <div className={`text-lg font-bold ${transaction.type === 'credit' ? 'text-green-600' : 'text-red-600'}`}>
          {transaction.type === 'credit' ? '+' : '-'}{formatCurrency(transaction.amount)}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 text-sm">
        <div className="flex items-center text-gray-600">
          <FiUser className="mr-2 text-gray-400" />
          <span className="truncate">{transaction.first_name} {transaction.last_name}</span>
        </div>
        
        <div className="flex items-center text-gray-600">
          <FiCreditCard className="mr-2 text-gray-400" />
          <span>Fees: {formatCurrency(transaction.total_fees)}</span>
        </div>
        
        <div className="flex items-center text-gray-600">
          <FiCalendar className="mr-2 text-gray-400" />
          <span>{new Date(transaction.created_at).toLocaleDateString()}</span>
        </div>
        
        <div className="text-right">
          <span className="text-gray-500">Fee %:</span>
          <span className="ml-1 font-medium">{parseFloat(transaction.fee_percentage || 0).toFixed(2)}%</span>
        </div>
      </div>

      <div className="mt-3 pt-3 border-t border-gray-100 grid grid-cols-2 gap-2 text-xs">
        <div>
          <span className="text-gray-500">Platform Fee:</span>
          <span className="ml-1 font-medium">{formatCurrency(transaction.platform_fee)}</span>
        </div>
        <div>
          <span className="text-gray-500">Processor Fee:</span>
          <span className="ml-1 font-medium">{formatCurrency(transaction.processor_fee)}</span>
        </div>
      </div>
    </div>
  );
};

export default FeeTransactionCard;